import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from ".././Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
import StudyCalculatorImg from "../../../images/StudyCalculatorImg.webp";
const TITLE = "حساب المعدل من 100 - حاسبة المعدل الجامعي";
const DESCRIPTION =
  "احسب معدلك الجامعي بدقة من خلال حاسبة المعدل الجامعي. تعرّف على كيفية حساب المعدل من 100 نقطة بسهولة واعرف حالة أدائك الأكاديمي.";
const KEYWORDS =
  "حساب المعدل من 100, حاسبة المعدل الجامعي, حساب المعدل الجامعي, معدل الأداء الأكاديمي";
const OG_URL = "https://do-calculate.com/calculator/ar/grade100";
function WeightedGradeCalculator() {
  const [assignments, setAssignments] = useState([
    { name: "المادة 1", grade: "90", weight: "100" },
    { name: "المادة 2", grade: "80", weight: "100" },
    { name: "المادة 3 ", grade: "70", weight: "100" },
  ]);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [weightedScore, setWeightedScore] = useState(0);
  const [weightedGrade, setWeightedGrade] = useState("");
  const [weightedGPA, setWeightedGPA] = useState(0);
  const calculateWeightedGrade = () => {
    setIsLoading(true);
    setError(null);
    let totalWeightedScore = 0;
    let totalWeight = 0;
    for (const assignment of assignments) {
      const grade = parseFloat(assignment.grade);
      const weight = parseFloat(assignment.weight);
      if (!isNaN(grade) && !isNaN(weight)) {
        totalWeightedScore += (grade / 100) * weight;
        totalWeight += weight;
      }
    }
    if (totalWeight === 0) {
      setError("الرجاء إدخال قيم صحيحة للواجبات والأوزان.");
    } else {
      const calculatedWeightedScore = (totalWeightedScore / totalWeight) * 100;
      setWeightedScore(calculatedWeightedScore.toFixed(2));
      const calculatedWeightedGrade = calculateWeightedGradeLetter(
        calculatedWeightedScore
      );
      setWeightedGrade(calculatedWeightedGrade);
      const calculatedWeightedGPA = calculateWeightedGPA(
        calculatedWeightedScore
      );
      setWeightedGPA(calculatedWeightedGPA.toFixed(2));
    }
    setIsLoading(false);
  };
  const calculateWeightedGradeLetter = (weightedScore) => {
    if (weightedScore >= 90) {
      return "A";
    } else if (weightedScore >= 80) {
      return "B";
    } else if (weightedScore >= 70) {
      return "C";
    } else if (weightedScore >= 60) {
      return "D";
    } else {
      return "F";
    }
  };
  const calculateWeightedGPA = (weightedScore) => {
    if (weightedScore >= 90) {
      return 4.0;
    } else if (weightedScore >= 80) {
      return 3.0;
    } else if (weightedScore >= 70) {
      return 2.0;
    } else if (weightedScore >= 60) {
      return 1.0;
    } else {
      return 0.0;
    }
  };
  const addAssignment = () => {
    setAssignments([...assignments, { name: "", grade: "", weight: 100 }]);
  };
  const removeAssignment = (index) => {
    const updatedAssignments = [...assignments];
    updatedAssignments.splice(index, 1);
    setAssignments(updatedAssignments);
  };
  const handleInputChange = (index, event) => {
    const { name, value } = event.target;
    const updatedAssignments = [...assignments];
    updatedAssignments[index][name] =
      name === "weight" && value === "" ? "100" : value;
    setAssignments(updatedAssignments);
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
        IMAGE={StudyCalculatorImg}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>{DESCRIPTION}</p>
                <hr />
              </div>
              <br />
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>
                    حساب المعدل الجامعي من 100
                  </h2>
                </div>
                <hr />
                <div className="form-group d-flex align-items-center text-center">
                  <div style={{ width: "100%", marginLeft: "4px" }}>
                    <b>
                      <label htmlFor="assignment">الواجب/الامتحان</label>
                    </b>
                  </div>
                  <div style={{ width: "75px", marginLeft: "4px" }}>
                    <b>
                      <label htmlFor="grade">العلامة</label>
                    </b>
                  </div>

                    <div style={{ width: '75px', marginLeft: '4px', display: 'inline-block' }}>
                      <b><label>الوزن</label></b>
                      <button
                        type="button"
                        style={{
                          background: 'none',
                          border: 'none',
                          padding: '0',
                          cursor: 'help',
                          marginLeft: '5px'
                        }}
                        title="اترك حقل الوزن فارغًا إذا لم تكن لموادك أوزان. القيمة الافتراضية هي 100%"
                      >
                        ℹ️
                      </button>
                    </div>
                  </div>
                {assignments.map((assignment, index) => (
                  <div key={index}>
                    <div className="form-group d-flex align-items-center">
                      <input
                        type="text"
                        name="name"
                        id="assignment"
                        placeholder="المادة/الامتحان"
                        value={assignment.name}
                        style={{ width: "100%", marginLeft: "4px" }}
                        className="form-control ml-2"
                        onChange={(e) => handleInputChange(index, e)}
                      />
                      <input
                        type="number"
                        name="grade"
                        id="grade"
                        placeholder="75"
                        value={assignment.grade}
                        className="form-control ml-2"
                        style={{ width: "75px", marginLeft: "4px" }}
                        onChange={(e) => handleInputChange(index, e)}
                      />
                      <input
                        type="number"
                        name="weight"
                        id="weight"
                        placeholder="100"
                        value={assignment.weight}
                        className="form-control ml-2"
                        style={{ width: "75px", marginLeft: "2px" }}
                        onChange={(e) => handleInputChange(index, e)}
                      />
                      <span
                        className="input-group-text "
                        style={{ marginLeft: "4px" }}
                      >
                        %
                      </span>
                      <button
                        className="text-white btn bg-secondary"
                        onClick={() => removeAssignment(index)}
                      >
                        حذف
                      </button>
                    </div>
                    <div>
                      <br />
                    </div>
                  </div>
                ))}
                <button
                  className="text-white btn bg-success"
                  onClick={addAssignment}
                >
                  إضافة مادة/امتحان
                </button>
                <div>
                  <br />
                </div>
                <button
                  className="text-white btn bg-success"
                  style={{ fontSize: "20px" }}
                  onClick={calculateWeightedGrade}
                  disabled={isLoading}
                >
                  احسب                </button>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12 col-md-7">
                <br />
                {error && (
                  <div className="alert alert-warning">
                    <b>
                      <u>حدث خطأ:</u>
                    </b>{" "}
                    {error}
                  </div>
                )}
                {weightedScore > 0 && (
                  <div className="bg-light bg-gradient text-dark">
                    <div className="p-3 mb-2 bg-success bg-gradient text-white">
                      <strong>النتائج</strong>
                    </div>
                    <b>العلامة المرجحة (من 100):</b> {weightedScore}%
                    <br />
                    <b>العلامة المرجحة:</b> {weightedGrade}
                    <br />
                  </div>
                )}
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
            </div>
            <hr />
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">{TITLE}</div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                  </u>
                  <p>
                    لحساب المعدل الوزني المرجح لسنتك الجامعية أو وحدتك الدراسية
                    أو مهمتك، نقوم بضرب العلامات (أو الدرجات) فيها بأوزانها
                    المقابلة، ثم نجمعها معًا، وبعد ذلك نقسم الإجمالي على مجموع
                    الأوزان. فيما يلي مثال ويتم عرض الحساب في أسفل النتائج.
                  </p>
                  <table >
                    <tbody>
                      <tr className="gpa-header">
                        <th>العلامة</th>
                        <th>الوزن</th>
                        <th>الوحدة</th>
                      </tr>
                      <tr>
                        <td>66%</td>
                        <td>20 وحدة</td>
                        <td>تحليل البيانات</td>
                      </tr>
                      <tr>
                        <td>55%</td>
                        <td>10 وحدات</td>
                        <td>قواعد البيانات</td>
                      </tr>
                      <tr>
                        <td>71%</td>
                        <td>10 وحدات</td>
                        <td>تصميم التجارب</td>
                      </tr>
                    </tbody>
                  </table>
                  <p>
                    المتوسط = (66 × 20 + 55 × 10 + 71 × 10) / (20 + 10 + 10)
                  </p>
                  <p>
                    بناءً على ذلك، يتم حساب متوسط العلامة للطالب A عند 64.5%.
                  </p>
                  <hr />
                </div>
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>المواد غير الموزونة</h2>
                  </u>
                  <p>
                    إذا كنت ترغب في إجراء حساب غير مرجح، ببساطة اترك جميع حقول
                    الأوزان فارغة، أو قم بجعلها متساوية. إذا كنت ترغب في معرفة
                    العلامة التي تحتاجها في امتحانك النهائي.
                  </p>
                  <hr />
                </div>
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default WeightedGradeCalculator;
